import { Course, CourseSettings, Lesson, Test, CourseMember, UserProgress } from "./types";

import * as Actions from './actions.type'
import * as Mutations from './mutations.type'
import * as Services from './services'

interface State {
  list: Course[], // список курсов для начальной страницы
  item: Course | null,  // открытый курс при редактировании в диалоге
  activeCourse: Course | null, // страница открытого курса
  activeLesson: Lesson | null, // страница открытого курса
  activeTest: Test | null, // страница открытого курса
  courseSettings: CourseSettings | null,
  courseMembers: CourseMember[],
  userProgress: UserProgress | null,  // прогресс тестирования
  analyticsData: any[],
  analyticsUserData: any,
  testStatisticData: any[], // данные по тесту открытому под админом
  lessonStatisticData: any[], // данные по уроку открытому под админом
  dashboardData: any, // данные по компании
}

const store: State = {
  list: [],
  item: null,
  activeCourse: null,
  activeLesson: null,
  activeTest: null,
  courseSettings: null,
  courseMembers: [],
  userProgress: null,
  analyticsData: [],
  analyticsUserData: null,
  testStatisticData: [],
  lessonStatisticData: [],
  dashboardData: null,
}

const actions = {
  [Actions.GET_ADMINS]: Services.getAdmins,
  [Actions.SAVE_ADMINS]: Services.setAdmins,
  [Actions.GET_MEMBERS]: Services.getMembers,
  [Actions.SET_MEMBERS]: Services.setMembers,
  [Actions.NEW_QUESTION]: Services.addQuestion,
  [Actions.EDIT_QUESTION]: Services.editQuestion,
  [Actions.DELETE_QUESTION]: Services.deleteQuestion,
  [Actions.START_TEST]: Services.startTest,
  [Actions.SEND_ANSWER]: Services.sendAnswer,
  // [Actions.END_TEST]: Services.endTest,
  [Actions.GET_USER_PROGRESS]: Services.getUserProgress,
  [Actions.GET_ANALYTIC]: Services.getAnalytic,
  [Actions.GET_TEST_STAT]: Services.getTestStatistic,
  [Actions.GET_LESSON_STAT]: Services.getLessonStatistic,
  [Actions.LEARN_LESSON]: Services.learnLesson,
  [Actions.GET_DASHBOARD_DATA]: Services.getDashboardData,
}
const mutations = {
  [Mutations.SET_ADMINS](state: State, admins: string[]) {
    state.courseSettings = {admins}
  }
}

const getters = {
  // указывает что тест пройден хотя бы один раз
  wasPassed: (s: State) => Boolean(Object.keys(s.testStatisticData || {}).length),
}


export default {
  namespaced: true,
  state: store,
  getters,
  actions,
  mutations,
};